export default "__VITE_ASSET__BgLNRzNh__"